export const ADD_POLICY_DETAIL = 'ADD_POLICY_DETAIL'
export const FETCH_POLICY_VAS_DETAIL = 'FETCH_POLICY_VAS_DETAIL'
